import { render } from "./Hata_ErisimYetkisi.vue?vue&type=template&id=5df045be&scoped=true"
import script from "./Hata_ErisimYetkisi.vue?vue&type=script&lang=js"
export * from "./Hata_ErisimYetkisi.vue?vue&type=script&lang=js"

import "./Hata_ErisimYetkisi.vue?vue&type=style&index=0&id=5df045be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cosku\\OneDrive\\Masaüstü\\DiyetisyenYagmurDemir\\GT Yönetim Sistemi - Kopya\\Yönetim Sistemi - Frontend\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df045be"]])

export default __exports__